import { render } from "./myInvoice.vue?vue&type=template&id=4968c3ed"
import script from "./myInvoice.vue?vue&type=script&lang=js"
export * from "./myInvoice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__